module.exports = __webpack_public_path__ + "img/obelisc.6aff472f.png";